import type { PublicConfig } from './types'

let csrfToken = ''

async function ensureCSRF() {
  if (csrfToken) return csrfToken
  const response = await fetch('/api/auth/csrf', { credentials: 'include' })
  if (!response.ok) throw new Error('Could not initialize a secure session.')
  csrfToken = (await response.json()).csrfToken
  return csrfToken
}

export class APIError extends Error { constructor(message:string, public status:number, public data:Record<string,unknown>|null=null){super(message)} }

export function isPurchasePausedError(error: unknown): error is APIError {
  return error instanceof APIError && error.status === 503 && error.data?.type === 'purchases_paused'
}

export function isQuoteRefreshError(error: unknown): error is APIError {
  return error instanceof APIError && error.status === 409 && error.data?.type === 'quote_requires_refresh'
}

export async function api<T>(path:string, init:RequestInit = {}):Promise<T> {
  const method = (init.method || 'GET').toUpperCase()
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type','application/json')
  if (!['GET','HEAD','OPTIONS'].includes(method)) headers.set('X-CSRF-Token', await ensureCSRF())
  const response = await fetch(path, { ...init, headers, credentials:'include' })
  if (!response.ok) {
    const body = await response.json().catch(()=>null) as ({detail?:string}&Record<string,unknown>)|null
    throw new APIError(body?.detail || `Request failed (${response.status})`, response.status, body)
  }
  if (response.status === 204) return undefined as T
  return response.json() as Promise<T>
}

export const getConfig = () => api<PublicConfig>('/api/config')
export const postJSON = <T>(path:string, body:unknown) => api<T>(path,{method:'POST',body:JSON.stringify(body)})
